import { render } from "./ConcertGame.vue?vue&type=template&id=6c78fc00&scoped=true&ts=true"
import script from "./ConcertGame.vue?vue&type=script&lang=ts"
export * from "./ConcertGame.vue?vue&type=script&lang=ts"

import "./ConcertGame.vue?vue&type=style&index=0&id=6c78fc00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c78fc00"]])

export default __exports__